import EthereumService from '@/services/ethereum'

export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapApi = options.kulapApi
  }
  async sendConfirmationEmail (recaptchaToken) {
    const { data } = await this.kulapApi.sendConfirmationEmail(recaptchaToken)
    return data
  }
}



// WEBPACK FOOTER //
// ./src/pages/SendConfirmationEmail/service.js